var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOrganised5X5Pattern(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 354,
    height: 354,
    viewBox: "0 0 354 354",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 176.804C0 166.621 8.25475 158.366 18.4375 158.366H97.6207C107.803 158.366 116.058 166.621 116.058 176.804C116.058 186.986 107.803 195.241 97.6207 195.241H36.875V256.379C36.875 266.562 28.6203 274.816 18.4375 274.816C8.25475 274.816 0 266.562 0 256.379V176.804Z",
    fill: "#193718"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 18.4375C0 8.25475 8.25475 0 18.4375 0H97.6207C107.803 0 116.058 8.25475 116.058 18.4375C116.058 28.6203 107.803 36.875 97.6207 36.875H39.7244C47.5532 61.4629 70.6141 79.1832 97.6207 79.1832C107.803 79.1832 116.058 87.438 116.058 97.6207C116.058 107.803 107.803 116.058 97.6207 116.058C43.9859 116.058 0 72.5832 0 18.4375Z",
    fill: "#193718"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M335.563 79.1833C345.745 79.1833 354 87.4381 354 97.6208V176.804C354 186.987 345.745 195.242 335.563 195.242H256.379C246.197 195.242 237.942 186.987 237.942 176.804C237.942 166.621 246.197 158.367 256.379 158.367H317.125V97.6208C317.125 87.4381 325.38 79.1833 335.563 79.1833Z",
    fill: "#193718"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M237.942 256.379C237.942 246.196 246.197 237.942 256.379 237.942C310.525 237.942 354 281.928 354 335.562C354 345.745 345.745 354 335.563 354H256.379C246.197 354 237.942 345.745 237.942 335.562C237.942 325.38 246.197 317.125 256.379 317.125H314.267C306.467 292.666 283.569 274.817 256.379 274.817C246.197 274.817 237.942 266.562 237.942 256.379Z",
    fill: "#193718"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M158.366 18.4375C158.366 8.25475 166.621 0 176.804 0H335.562C345.745 0 354 8.25475 354 18.4375C354 28.6203 345.745 36.875 335.562 36.875H176.804C166.621 36.875 158.366 28.6203 158.366 18.4375Z",
    fill: "#193718"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M256.379 0C266.562 0 274.817 8.25475 274.817 18.4375V97.6207C274.817 107.803 266.562 116.058 256.379 116.058C246.197 116.058 237.942 107.803 237.942 97.6207V18.4375C237.942 8.25475 246.197 0 256.379 0Z",
    fill: "#193718"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 335.563C0 325.38 8.25475 317.125 18.4375 317.125H176.804C186.987 317.125 195.241 325.38 195.241 335.563C195.241 345.745 186.987 354 176.804 354H18.4375C8.25475 354 0 345.745 0 335.563Z",
    fill: "#193718"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M97.6206 237.942C107.803 237.942 116.058 246.196 116.058 256.379V335.562C116.058 345.745 107.803 354 97.6206 354C87.4379 354 79.1831 345.745 79.1831 335.562V256.379C79.1831 246.196 87.4379 237.942 97.6206 237.942Z",
    fill: "#193718"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M176.804 79.1833C186.987 79.1833 195.241 87.4381 195.241 97.6208V256.379C195.241 266.562 186.987 274.817 176.804 274.817C166.621 274.817 158.366 266.562 158.366 256.379V97.6208C158.366 87.4381 166.621 79.1833 176.804 79.1833Z",
    fill: "#193718"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrganised5X5Pattern);
export default __webpack_public_path__ + "static/media/organised_5x5_pattern.b817308dc302f55135ec3e27f2152229.svg";
export { ForwardRef as ReactComponent };